import React from 'react'


const StoreContext = React.createContext({
  store: {
    getState: () => {},
    subscribe: () => {},
    dispatch: () => {},
  },
  storeEvents: {
    has: () => {},
    unsubscribe: () => {},
    subscribe: () => {},
    dispatch: () => {},
  },
})


export default StoreContext
